/**
 * Joins CSS Module class names.
 *
 * `vite/client` types a CSS Module as `{ readonly [key: string]: string }`, and this repo
 * compiles with `noUncheckedIndexedAccess`, so `s.primary` is `string | undefined` — a
 * typo in a class name is `undefined` at the type level rather than a silent no-op at
 * runtime. Every primitive composes its classes through here so that stays true.
 */
export const cx = (...parts: ReadonlyArray<string | false | null | undefined>): string =>
  parts.filter((p): p is string => typeof p === 'string' && p.length > 0).join(' ');
